export default {
    parts: [
        'skeletonGrid',
        'skeletonItem',
        'productGrid',
        'productItem',
        'noResults'
    ],
    baseStyle: {
        skeletonGrid: {
            templateColumns: 'repeat(2, 1fr)',
            gridColumnGap: 2,
            gridRowGap: 3,
            mt: 4
        },
        skeletonItem: {},
        productGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gridColumnGap: 2,
            gridRowGap: 3,
            width: '100%'
        },
        productItem: {
            width: '100%',
            minWidth: '0'
        },
        noResults: {
            mt: 10
        }
    }
}
